import React, {useEffect, useState} from 'react';
import {
    GET_COL_AGGREGATE_DATA,
    SEARCH_COLLECTION_URL
} from '../../api';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import {Link} from "react-router-dom";
import cogoToast from "cogo-toast";
import {polling, sync} from "../../api/app";
import ViewGMap from "../../components/layout/ViewGMap";
import PinMap from "../../components/layout/PinMap";
import {capitalize} from "../../utils/capitalize";
import 'components-jqueryui';
import 'select2';
import formatNumber from "../../utils/formatNumber";
import {useDispatch, useSelector} from "react-redux";

let searchableFields = [
    { field: 'delimitation_code', isNumeric: false },
    { field: 'name', isNumeric: false },
    { field: 'ward.name', isNumeric: false },
    { field: 'ward.constituency.name', isNumeric: false },
    { field: 'ward.constituency.administrative.name', isNumeric: false }
]

const Polling = () => {

    document.title = "Polling Station";

    const [stateReady, setStateReady] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [editId, setEditId] = useState(0);
    const [openMap, setOpenMap] = useState(true);
    const [pinCoordinates, setPinCoordinates] = useState(null);
    const [coordinate, setCoordinate] = useState([
        -15.444927790349599,
        28.314533438533545
    ]);

    const dispatch = useDispatch();

    const token = localStorage.getItem('jwtToken');

    const {province, constituencies, wards} = useSelector(state => state.app?.administrative);

    useEffect(() => {
        dispatch(sync());
    }, []);

    useEffect(() => {
        let table = $('#polling_station').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Polling Station Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                const term = (data.search.value || '').trim();
                const searchMatch = term ? {
                    $match: {
                        $or: [
                            { name: { $regex: term, $options: 'i' } },
                            { delimitation_code:  { $regex: term, $options: 'i' } }
                        ]
                    }
                } : null;

                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: $('.dataTables_filter input').val(),
                        collection: "polling",
                        filter: [
                            ...(searchMatch ? [searchMatch] : []),
                            {
                                $facet: {
                                    results: [
                                        {
                                            $lookup: {
                                                from: "memberships",
                                                let: { pollingId: "$_id" },
                                                pipeline: [
                                                    { $match: { $expr: { $eq: ["$polling_station", "$$pollingId"] } } },
                                                    { $count: "total" }
                                                ],
                                                as: "members"
                                            }
                                        },
                                        {
                                            $addFields: {
                                                membership_total: {
                                                    $ifNull: [{ $arrayElemAt: ["$members.total", 0] }, 0]
                                                }
                                            }
                                        },
                                        { $unset: "members" },
                                        { $sort: { membership_total: -1 } },
                                        { $skip: data.start },
                                        { $limit: data.length },
                                        {
                                            $lookup: {
                                                from: "wards",
                                                localField: "ward",
                                                foreignField: "_id",
                                                as: "ward"
                                            }
                                        },
                                        { $unwind: { path: "$ward", preserveNullAndEmptyArrays: true } },
                                        {
                                            $lookup: {
                                                from: "constituencies",
                                                localField: "ward.constituency",
                                                foreignField: "_id",
                                                as: "constituency"
                                            }
                                        },
                                        { $unwind: { path: "$constituency", preserveNullAndEmptyArrays: true } },
                                        {
                                            $lookup: {
                                                from: "administratives",
                                                localField: "constituency.administrative",
                                                foreignField: "_id",
                                                as: "administrative"
                                            }
                                        },
                                        { $unwind: { path: "$administrative", preserveNullAndEmptyArrays: true } },
                                        {
                                            $addFields: {
                                                "ward.constituency": {
                                                    _id: "$constituency._id",
                                                    name: "$constituency.name",
                                                    administrative: {
                                                        _id: "$administrative._id",
                                                        name: "$administrative.name"
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            $project: {
                                                _id: 1,
                                                name: 1,
                                                delimitation_code: 1,
                                                membership_total: 1,
                                                "ward._id": 1,
                                                "ward.name": 1,
                                                "ward.constituency": 1
                                            }
                                        }
                                    ],
                                    totalCount: [{ $count: "count" }]
                                }
                            }
                        ],
                        searchableFields,
                        pageSize: data.start,
                        format: 'json',
                        sort: {_id: -1},
                        pageIndex: (data.length + data.start) / data.length
                    }),
                    success: function (res) {
                        let records = res.data[0] || { results: [], totalCount: [] };
                        let total = records.totalCount.length > 0 ? records.totalCount[0].count : 0;

                        let array = records.results.map(row => ({ raw: row }));

                        callback({
                            recordsTotal: total,
                            recordsFiltered: total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.delimitation_code;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.name;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return formatNumber(data.membership_total);
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only">
<!--                                    <a href="#" class="nav-link edit_user"><i class="fa fa-pencil"></i> Edit</a> -->
                                    <a href="#" class="nav-link delete_polling"><i class="fa fa-trash-alt"></i> Delete</a>
                                </nav>`
                    },
                    "targets": 4
                }
            ]
        });

        table.on('click', '.delete_polling', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this polling station?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                polling("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Polling Station successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.edit_user', function(e) {
            e.preventDefault();

            let name = $("#name");
            let email = $("#email");
            let extract_td = table.row($(this).closest('tr')).data();

            setEditForm(true);
            setEditId(extract_td.raw._id);

            $('#agent_form').parsley();

            name.prop('disabled', true);
            email.prop('disabled', true);
            $("#password").prop('required', false);

            name.val(extract_td.raw.name);
            email.val(extract_td.raw.email);
            $('#b1a').prop({checked: extract_td.raw.permission.create});
            $('#b2a').prop({checked: extract_td.raw.permission.update});
            $('#b3a').prop({checked: extract_td.raw.permission.delete});

            $("#modalAgent").modal("show");
        });

        $('#polling_station tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row

            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Ward:</td>' +
                '<td class="text-capitalize">' +
                d?.raw?.ward.name +
                '<tr>' +
                '<td>Constituency:</td>' +
                '<td>' +
                d?.raw?.ward.constituency.name +
                '<tr>' +
                '<td>Administrative:</td>' +
                '<td>' +
                d?.raw?.ward.constituency.administrative.name +
                '</table>'
            );
        }

        return () => {
            table.destroy();
        }
    }, []);

    const handlePollingSubmit = async(e) => {
        e.preventDefault();

        if(pinCoordinates == null) return cogoToast.error("Attention: Please Pin a Location.", {position: "top-right", hideAfter: 5});

        setStateReady(true);

        let data = {
            name: $("#polling-name").val(),
            ward: $("#ward-select2").val()[0],
            delimitation_code: $("#delimitation-code").val(),
            location: {
                lat: pinCoordinates.lat,
                lng: pinCoordinates.lng
            }
        }

        polling("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Data successfully updated.", {position: "top-right", hideAfter: 5});
                $('#polling_station').DataTable().ajax.reload();
                setPinCoordinates(null);
                setOpenMap(false);
                resetForm("modalPolling", "polling_form");
            }
        })

        return false;
    }

    const initializeWardSearch = () => {
        let modalProduct = $('#modalPolling');
        $('#ward-select2').select2({
            placeholder: 'Select ward type or type name',
            allowClear: true,
            width:"100%",
            maximumSelectionLength: 1,
            dropdownParent: modalProduct,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization": token,
                },
                data: function(query) {
                    return {
                        query: query,
                        collection: "ward",
                        populate: [
                            {
                                path: 'constituency',
                                model: 'constituency',
                                populate: {
                                    path: 'administrative',
                                    model: 'administrative',
                                }

                            }
                        ]
                    };
                },
                processResults: function(data) {
                    return {
                        results: $.map(data, function(item) {
                            return {
                                text: capitalize(`${item.name}, ${item.constituency.name}, ${item.constituency.administrative.name}`),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        });
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        setOpenMap(false);
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const handlePinLocation = (coordinates) => {
        setPinCoordinates(coordinates);
    };

    const handleOpenMap = () => {
        setCoordinate({lat: -15.444927790349599, lng: 28.314533438533545});

        $("#modalMap").modal({ backdrop: 'static', focus: false, show: true });
        setOpenMap(true);
    }

    const handleShowModal = () => {
        setEditForm(false);
        $('#polling_form').parsley();
        initializeWardSearch();
        setOpenMap(true);
        $("#modalPolling").modal({ backdrop: 'static', focus: false, show: true });
    };

    const reloadTable = () => {
        $('#polling_station').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Polling Station</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Polling Station</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-success btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-globe"></i> Add New</button>
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleOpenMap.bind()}><i className="wd-10 mg-r-5 fa fa-map"></i> View Map</button>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Polling Station List</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable.bind()} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="polling_station" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-25p">Delimitation Code</th>
                                        <th className="wd-25p">Name</th>
                                        <th className="wd-25p">Total Membership</th>
                                        <th className="wd-25p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalPolling" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={() => {
                                        setOpenMap(false);
                                        setPinCoordinates(null);
                                        resetForm.bind(null, "modalPolling", "polling_form");
                                    }} aria-label="Close"><span aria-hidden="true">×</span></a>
                                        <h4 className="tx-18 tx-sm-20 mg-b-2">Polling Station</h4>
                                        <p className="tx-13 tx-color-02 mg-b-0">Polling information.</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="polling_form" className="parsley-style-1" onSubmit={handlePollingSubmit.bind()}>
                                        <div id="nameWrapper" className="form-group parsley-input">
                                            <label>Name<span className="tx-danger">*</span></label>
                                            <input id="polling-name" type="text" className="form-control"
                                                   placeholder="Enter name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nameWrapper" required/>
                                        </div>

                                        <div id="wardWrapper" className="form-group parsley-input">
                                            <div className="d-flex justify-content-between">
                                                <label>Ward<span className="tx-danger">*</span></label>
                                            </div>
                                            <select className="form-control" id="ward-select2" data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#wardWrapper"
                                                    data-parsley-errors-container="#wardWrapper"
                                                    autoComplete="off"
                                                    required>
                                            </select>
                                        </div>

                                        <div id="codeWrapper" className="form-group parsley-input">
                                            <label>Delimitation Code</label>
                                            <input id="delimitation-code" type="text" className="form-control"
                                                   placeholder="Enter delimitation code"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#codeWrapper"
                                                   required
                                            />
                                        </div>

                                        {openMap ? <PinMap onPinLocation={handlePinLocation}/> : null}

                                        {stateReady ? <button disabled className="btn btn-success btn-block mt-3"><span
                                                className="spinner-border spinner-border-sm mg-r-10" role="status"
                                                aria-hidden="true"/>Please Wait</button> :
                                            <button className="btn btn-success btn-block mt-3">Add Polling Station</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalMap" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15"
                                       data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close"><span
                                        aria-hidden="true">×</span></a>
                                        <h4 className="tx-18 tx-sm-20 mg-b-2">View Map</h4>
                                        <p className="tx-13 tx-color-02 mg-b-0">Map information.</p>
                                    </div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    {openMap ? <ViewGMap coordinate={coordinate}/> : null}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p className="mg-b-0 data-message">Empty</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                    <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Polling;
